import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import TagForm from "composer/views/stage/PlaybackElement/Tag/TagForm.jsx"
import MCForm from "composer/views/stage/PlaybackElement/MC/MCForm.jsx"
import PortalForm from "composer/views/stage/PlaybackElement/Portal/PortalForm.jsx"
import VoiceAnsForm from "composer/views/stage/PlaybackElement/VoiceClip/VoiceAnsForm.jsx"
import TreasureForm from "composer/views/stage/PlaybackElement/Treasure/TreasureForm.jsx"
import TeleportForm from "composer/views/stage/PlaybackElement/Teleport/TeleportForm.jsx"

class ElementFactory extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      activeView: 0,
    };
    autoBind(this);
  }

  validateInput() {
    return this.refs.elementForm.validateInput();
  }

  createPlayback() {
    let requestObj = { stage_id: this.props.stageData['id'] };
    this.props.root.refs.API.request('create_playback', requestObj, this.createPlaybackOK, this.createPlaybackFailed);
  }

  createPlaybackOK(res) {
    let new_id = res.body['result'];
    this.updatePlayback(new_id);
  }

  createPlaybackFailed(err) {
    console.log("create playback failed");
  }

  updatePlayback(playbackID) {
    this.refs.elementForm.updatePlayback(playbackID);
  }

  updatePlaybackOK(res) {
    if (this.refs.elementForm.updatePlaybackOK) {
      this.refs.elementForm.updatePlaybackOK(res);
    }
    this.props.root.refs.stageViewerPage.refs.stageDetailView.refresh();

    if (this.props.parent.onUpdatePlayback) {
      this.props.parent.onUpdatePlayback();
    }

    //somehow refresh the media view in order to update the tag position
    // this.props.root.refs.stageViewerPage.refs.stageDetailView.refs.stageMediaView.refreshPlaybackTime();
  }

  updatePlaybackFailed(err) {
    if (this.refs.elementForm.updatePlaybackFailed) {
      this.refs.elementForm.updatePlaybackFailed(err);
    }
    console.log("update playback failed");
  }

  visibilityToCountdownLimit(visibility) {
    let countdownLimit = 3600;
    switch (visibility) {
      case 0:
        countdownLimit = 3600;
        break;
      case 1:
        countdownLimit = 120;
        break;
      case 2:
        countdownLimit = 60;
        break;
      case 3:
        countdownLimit = 45;
        break;
      case 4:
        countdownLimit = 30;
        break;
      case 5:
        countdownLimit = 15;
        break;
      default:
        break;
    }
    return countdownLimit;
  }

  countdownLimitToVisibility(countdownLimit) {
    let visibility = 0;
    if (countdownLimit > 120) {
      visibility = 0;
    }
    else{
      visibility = 1;
    }
    return visibility;
  }

  render() {
    let playbackData = this.props.playbackData;
    let elementType = this.props.elementType;
    if (playbackData != null) {
      elementType = parseInt(playbackData['kind']);
    }
    return (
      <div>
        <Switch condition={elementType}>
          <Case value={1}>
            <TagForm parent={this} root={this.props.root} ref="elementForm"
              playbackData={playbackData}
            />
          </Case>
          <Case value={2}>
            <MCForm parent={this} root={this.props.root} ref="elementForm"
              playbackData={playbackData}
            />
          </Case>
          <Case value={3}>
            <PortalForm parent={this} root={this.props.root} ref="elementForm"
              playbackData={playbackData}
            />
          </Case>
          <Case value={4}>
            <VoiceAnsForm parent={this} root={this.props.root} ref="elementForm"
              playbackData={playbackData}
            />
          </Case>
          <Case value={5}>
            <TreasureForm parent={this} root={this.props.root} ref="elementForm"
              playbackData={playbackData}
            />
          </Case>
          <Case value={6}>
            <TeleportForm parent={this} root={this.props.root} ref="elementForm"
              playbackData={playbackData}
            />
          </Case>
        </Switch>
      </div>
    )
  }
}

export default ElementFactory;
